import { jsx as l } from "react/jsx-runtime";
const o = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M18.95 2a3.05 3.05 0 0 0-2.15.886L14.24 5.36 7.316 3.05a1 1 0 0 0-1.023.242l-2.5 2.5a1 1 0 0 0 .233 1.588l5.317 2.862L7.586 12H5a1 1 0 0 0-.707.293l-2 2a1 1 0 0 0 .39 1.656L6.71 17.29l1.342 4.025a1 1 0 0 0 1.656.391l2-2A1 1 0 0 0 12 19v-2.586l1.754-1.753 2.864 5.36a1 1 0 0 0 1.596.23l2.5-2.55a1 1 0 0 0 .235-1.017L18.64 9.759l2.474-2.558A3.05 3.05 0 0 0 18.95 2",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
